<template>
    <button-link
        ref="buttonElement"
        :aria-label="ariaLabel || $t('common.actions', 2)"
        :icon="icon"
        :theme="theme"
        :icon-size="iconSize"
        :disabled="disabled"
        type="button"
        @click.prevent.stop="openPopup"
    />
</template>

<script setup>
import { ref } from "vue"
import { usePopupActions } from "front-toolkit/plugins/PopupPlugin"
import { useScreenSize } from "front-toolkit/plugins/ScreenSizePlugin"
import ActionsPopup from "./ActionsPopup"
import ButtonLink from "./ButtonLink"

const props = defineProps({
    ariaLabel: {
        type: String,
        default: "",
    },
    icon: {
        type: String,
        default: "more",
    },
    theme: {
        type: String,
        default: "gray-dark",
    },
    iconSize: {
        type: Number,
        default: 24,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    actions: {
        type: Array,
        required: true,
    },
})

const emit = defineEmits(["action"])
const { pushPopup } = usePopupActions()
const { isDesktop } = useScreenSize()

const buttonElement = ref(null)
let popup = null

const openPopup = () => {
    if (props.disabled) return
    if (popup?.pop()) return

    popup = pushPopup({
        parentClass: defaultValue => {
            if (isDesktop.value) {
                return defaultValue
            } else {
                return "position-fixed left-0 top-0 w-100 h-100 d-flex flex-column justify-content-end bg--black--50"
            }
        },
        parentStyle: defaultValue => {
            if (isDesktop.value) {
                return defaultValue
            } else {
                return ""
            }
        },
        component: ActionsPopup,
        ref: buttonElement.value.$el,
        props: {
            actions: props.actions,
        },
        on: {
            action: event => {
                popup.pop()
                emit("action", event)
            },

            close: () => {
                popup.pop()
            },
        },
    })
}
</script>
